export default __webpack_public_path__ + "static/media/feature1_5.8fcd359d.png";